import React, { useContext } from "react";
import { Modal, Button } from "react-bootstrap";
import styled from "styled-components";
import SiteGlobalStyles from "../../../style/site-global-styles";
import classNames from "classnames";
import CloseIcon from '../../../icons/close-icon-gray.svg';
import Picture from "../../Picture";
import ModalContext  from "../../../context/ModalContext";
import { AutomationTestIdElementType, AutomationPlacement, createDataTestId } from "../../../utilities/automation";

export const MODALSIZES = {
    LOGIN: "345px",
    DISCLAIMER: "800px",
    VIDEO: "900px",
    SEARCH: "900px",
    FULL: "100%",
};

export interface IBaseModalProps {
    modalId: string;
    className?: string;
    hideHeader?: boolean;
    modalSize?: string;
    centered?: boolean;
    onClose?: () => void;
    hideStickyHeader?: boolean;
    dialogClassName?: string;
    backdropClassName?: string;
    children?: React.ReactElement|React.ReactElement[];
}

export default styled((props: IBaseModalProps) => {
    const { modalId, children, dialogClassName, hideStickyHeader = false, onClose = () => {}, modalSize, hideHeader, ...modalProps } = props;
    const { currentModal, closeModals } = useContext(ModalContext);
    const show = modalId === currentModal.modal;
    const handleClose = () => {
        onClose();
        closeModals();
    }

    return (
        <Modal
            animation={false}
            onHide={handleClose}
            show={show}
            {...modalProps}
            dialogClassName={classNames(dialogClassName, "m-auto")}
        >
            <Modal.Body className="p-3 p-md-0 border-none container">
                <SiteGlobalStyles>
                    {!props.hideHeader && 
                        <div className="d-flex justify-content-end">
                            <Button onClick={handleClose} variant="link" className="close-button" data-test-id={createDataTestId({placement: AutomationPlacement.MODAL, element: AutomationTestIdElementType.BUTTON, specifier: 'close'})}>
                                <Picture className="close-icon" src={CloseIcon} alt="close" />
                            </Button>
                        </div>
                    }
                    <div className="d-flex flex-column">
                        {children}
                    </div>
                </SiteGlobalStyles>
            </Modal.Body>
        </Modal>
    );
})`
padding-top: 130px;
background: rgba(236, 234, 233, 0.85);

.modal-content {
    border: 0;
}

.modal-dialog {
    width: 100%;
    max-width: ${props => props.modalSize || '100%'} !important;
}

.close-button {
    margin-bottom: 2.889rem;
    margin-right: -1.2rem;

    .close-icon {
        width: 18px;
    }
}


@media(max-width:992px) {
    padding-top: ${props => props.centered ? 0 : 110}px !important;
}
`;